import * as React from 'react';
import Container from '@mui/material/Container';

export default function MarloweDirections() {
  return (
    <Container sx={{
      height: "auto",
      aspectRatio: "16 / 9",
      maxHeight: "450px",
    }}>
      <iframe src="https://www.google.com/maps/embed?pb=!1m28!1m12!1m3!1d6202.705683653338!2d-71.07481837214893!3d42.36766222119234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m13!3e2!4m5!1s0x89e37769ce860ff5%3A0x7da9ccf3ac860cd0!2sKimpton%20Marlowe%20Hotel%2C%2025%20Edwin%20H%20Land%20Blvd%2C%20Cambridge%2C%20MA%2002141!3m2!1d42.367824999999996!2d-71.07493!4m5!1s0x89e3714c5f63f189%3A0xf245441112dd973!2sWashburn%20Pavilion%2C%20Museum%20Of%20Science%20Driveway%2C%20Boston%2C%20MA!3m2!1d42.3664503!2d-71.0703338!5e1!3m2!1sen!2sus!4v1735019867325!5m2!1sen!2sus"
        width="100%" 
        height="100%"
        allowfullScreen="" 
        loading="lazy" 
        referrerpolicy="no-referrer-when-downgrade" />
    </Container>
  );
}
